export const RAINFALL_SNAPSHOTS_SOURCE_ID = "rainfall-snapshots";
export const RAINFALL_SNAPSHOTS_FILL_LAYER = "rainfall-snapshots-fill";
export const RAINFALL_ACCUMULATION_SOURCE_ID = "rainfall-accumulation";
export const RAINFALL_ACCUMULATION_FILL_LAYER = "rainfall-accumulation-fill";

export const ACCUMULATION_WINDOW_OPTIONS = [
  { value: "30_MIN", label: "30 min" },
  { value: "1_HOUR", label: "1 hour" },
  { value: "3_HOUR", label: "3 hours" },
  { value: "6_HOUR", label: "6 hours" },
  { value: "12_HOUR", label: "12 hours" },
  { value: "24_HOUR", label: "24 hours" },
];

export const DEFAULT_ACCUMULATION_WINDOW = "1_HOUR";

export const RAINFALL_INTENSITY_LEGEND = [
  { label: "None", color: "#e2e8f0" },
  { label: "Light", color: "#93c5fd" },
  { label: "Moderate", color: "#3b82f6" },
  { label: "Heavy", color: "#6366f1" },
  { label: "Very heavy", color: "#a855f7" },
  { label: "Extreme", color: "#dc2626" },
  { label: "Unknown", color: "#94a3b8" },
];

export const RAINFALL_ACCUMULATION_LEGEND = [
  { label: "0 mm", color: "#f8fafc" },
  { label: "0–5 mm", color: "#dbeafe" },
  { label: "5–15 mm", color: "#60a5fa" },
  { label: "15–30 mm", color: "#2563eb" },
  { label: "30–50 mm", color: "#7c3aed" },
  { label: "50+ mm", color: "#b91c1c" },
];

export const RAINFALL_INTENSITY_FILL_EXPRESSION = [
  "match",
  ["get", "rainfall_intensity_label"],
  "NONE",
  "#e2e8f0",
  "LIGHT",
  "#93c5fd",
  "MODERATE",
  "#3b82f6",
  "HEAVY",
  "#6366f1",
  "VERY_HEAVY",
  "#a855f7",
  "EXTREME",
  "#dc2626",
  "#94a3b8",
];

export const RAINFALL_ACCUMULATION_FILL_EXPRESSION = [
  "step",
  ["get", "rainfall_total_mm"],
  "#f8fafc",
  0.01,
  "#dbeafe",
  5,
  "#60a5fa",
  15,
  "#2563eb",
  30,
  "#7c3aed",
  50,
  "#b91c1c",
];
